// vue-i18n@9 (Vue 3) 인스턴스.
// 사용자가 선택한 언어는 localStorage('lang') 에 저장한다.
// 지원: ko, en. 기본은 'ko'.
import { createI18n } from 'vue-i18n';
import ko from './locales/ko.json';
import en from './locales/en.json';

const SUPPORTED = ['ko', 'en'];
const stored = (typeof window !== 'undefined' && localStorage.getItem('lang')) || '';
const initial = SUPPORTED.includes(stored) ? stored : 'ko';

const i18n = createI18n({
  legacy: false,           // Composition API + globalInjection 모두 호환
  globalInjection: true,   // 템플릿에서 $t 사용 가능
  locale: initial,
  fallbackLocale: 'ko',
  messages: { ko, en },
  missingWarn: false,
  fallbackWarn: false
});

// 외부에서 언어를 바꿀 때 사용. localStorage 에도 같이 반영.
export function setLocale(lang) {
  if (!SUPPORTED.includes(lang)) return;
  i18n.global.locale.value = lang;
  try { localStorage.setItem('lang', lang); } catch (e) { /* ignore */ }
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', lang);
  }
}

// 초기 lang 속성 동기화
if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('lang', initial);
}

export default i18n;
